"use client";

import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import AppRoutes from "@/app/constants/routes";
import StringConstants from "@/app/constants/string-contants";
import { useMixPanel } from "@/app/context/mixPanelContext";
import ToastUtils from "@/app/toast/toast-utils";
import { getPlatformAndBrowser } from "@/app/utility/common";
import CustomButtonV2 from "@/app/versioning/components/v2/CustomButton/CustomButtonV2";
import {
  UniversalStorageConstants,
  UniversalStorageUtils,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
import { useRouter } from "next/navigation";
import { MouseEventHandler, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import OtpInput, { AllowedInputTypes } from "react-otp-input";
import CountDownTimerV2 from "../../../../FogotPasswordPage/v2/forgotComponent/countdowntimer-v2";

export function OTPRegisterPageV2({
  bearerToken,
  emailTemp = "",
  mobile = "",
  loginSourceValue = "",
  countryCode = "",
  editOnClick,
  switchSignInType,
  setshowOtpVerify = () => {},
  changeToken = () => {},
  setIsUserNameRegistered,
  isUserNameRegistered,
}: {
  switchSignInType: string;
  bearerToken?: string;
  loginSourceValue?: string;
  emailTemp?: string;
  mobile?: string;
  countryCode?: string;
  editOnClick?: MouseEventHandler<HTMLImageElement>;
  setshowOtpVerify?: Function;
  changeToken?: Function;
  setIsUserNameRegistered?: any;
  isUserNameRegistered?: boolean;
}) {
  const context = useAppContext();
  const { trackEvent } = useMixPanel();
  const {
    instances: { apiRepository },
    state: { user, isLoggedIn, memberships },
    fetchUserProfile,
  } = context;

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const { config } = useClientConfigProvider();
  const { t } = useTranslation();
  const router = useRouter();
  const [otp, setOtp] = useState("");
  const [showTimer, setShowTimer] = useState(true);
  const [email, setEmail] = useState("");
  const [token, setToken] = useState<string>("");
  const [hasError, setHasError] = useState<boolean>(false);
  const [isResendLoading, setIsResendLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!isLoggedIn) {
      trackEvent(EventLabels.SL_OTP, { screen: "Login" });
      trackEvent(EventLabels.SL_OTP_Done, { screen: "Login" });
    }
  }, []);

  useEffect(() => {
    if (bearerToken != null) {
      setToken(bearerToken ?? "");
      setEmail(emailTemp);
    }
  }, []);

  // useEffect(() => {
  //   if (user?.data?.firstName && memberships?.data?.length) {
  //     setTimeout(() => {
  //       console.log("otpR2");
  //       router.push(AppRoutes.dashboard);
  //     }, 3000);
  //   } else if (user?.data?.firstName && !memberships?.data?.length) {
  //     // setTimeout(() => {
  //     console.log("otpR2");
  //     router.push(
  //       config?.userRegistration?.afterRegistrationRedirectRoute ??
  //         AppRoutes.loginLinkMembership
  //     );
  //     // }, 300);
  //   }
  // }, [memberships?.data, user?.data]);

  useEffect(() => {
    if (!memberships?.isFetched || !user?.isFetched) return;
  }, [memberships?.isFetched, user?.isFetched, memberships?.data]);

  const handleInputChange = (event: any) => {
    if (event.key === "Enter") {
      confirmOTP();
    }
  };

  const confirmOTP = () => {
    if (otp.length < (config?.login?.otpConfig?.otpLength ?? 4)) {
      ToastUtils.showErrorToast("Please enter otp");
    } else {
      const deviceName =
        config?.limitMaxSessions == true ? getPlatformAndBrowser() : undefined;

      setIsLoading(true);
      apiRepository
        ?.verifyOTP(otp, token, { data: { secondaryOtp: "1234" } }, deviceName)
        .then((v) => {
          UniversalStorageUtils.setItem(
            config?.nativeDataSavingType,
            UniversalStorageConstants.AUTH_TOKEN,
            v.headers.authorization
          );
          console.log("checkuserafter", v?.data?.user?.firstName);
          setIsUserNameRegistered(v?.data?.user?.firstName);
          if (!v?.data?.user?.firstName) {
            router.push(AppRoutes.registerUserDetails);
          }
          ToastUtils.showSuccessToast(t("common.signInSuccess"));
          setshowOtpVerify(false);
          changeToken("");
          fetchUserProfile();
          // window.location.href = "/dashboard";
        })
        .catch((e) => {
          setHasError(true);
          setTimeout(() => {
            setHasError(false);
          }, 2000);
          setIsLoading(false);
          trackEvent(EventLabels.CTA_Submit_OTP, {
            screen: "Login",
            error:
              e?.response?.data?.message ??
              StringConstants.SOMETHING_WENT_WRONG,
          });
          ToastUtils.showErrorToast(
            e?.response?.data?.message ?? StringConstants.SOMETHING_WENT_WRONG
          );
        });
    }
  };

  return (
    <div className="login-form-container">
      <div className="otpscreen-main-v2">
        <h2 className="container-title header-only">Enter OTP</h2>

        <div>
          <div style={{ position: "relative" }}>
            <div className="login-flex-container">
              <div>
                <div className="otp-screen-v2">
                  <OtpInput
                    shouldAutoFocus
                    inputType={
                      config?.login?.otpConfig?.inputType as AllowedInputTypes
                    }
                    value={otp}
                    onChange={setOtp}
                    numInputs={config?.login?.otpConfig?.otpLength ?? 4}
                    containerStyle="otp-input-container-v2 otp-placeholder"
                    inputStyle={`otp-input-v2 ${hasError ? "error" : ""}`}
                    renderInput={(props, index) => {
                      const isFilled = otp?.[index] && otp[index] !== "";
                      return (
                        <input
                          {...props}
                          onKeyUp={handleInputChange}
                          placeholder="•"
                          className={`${props.className} ${
                            isFilled ? "filled" : ""
                          }`}
                        />
                      );
                    }}
                  />
                </div>

                <div className="resend-code-v2">
                  <div className="send-code-v2">
                    {/* OTP was sent to your {switchSignInType} */}
                    {t("registerLogin.otpSharedOnBankRegistered")}{" "}
                    {switchSignInType}
                  </div>
                  <div className="email-v2">{loginSourceValue}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="otp-confirmation-wrapper">
          <div className="resend-otp-text-v2">
            {showTimer && (
              <>
                <span className="timer-text">
                  You can resend OTP in &nbsp;
                  {/* This code will expire on &nbsp; */}
                </span>

                <div>
                  <span onClick={() => {}}>
                    <CountDownTimerV2
                      hoursMinSec={{
                        hours: 0,
                        minutes: 0,
                        seconds: config?.login?.otpConfig?.resendOtpTimer ?? 30,
                      }}
                      format={{
                        hours: false,
                        minutes: false,
                        seconds: true,
                      }}
                      cbFunc={() => {
                        setShowTimer(false);
                      }}
                    />
                  </span>
                </div>

                <span style={{ color: "var(--color-grayscale-text-title)" }}>
                  &nbsp;seconds
                </span>
              </>
            )}
          </div>
          <div className="otp-confirmation-wrapper--action-buttons">
            <CustomButtonV2
              fullWidth
              isLoading={isLoading}
              onClick={confirmOTP}
              hasShadow
              disabled={!(config?.login?.otpConfig?.otpLength === otp?.length)}
            >
              Verify
            </CustomButtonV2>

            {!config?.login?.otpConfig?.resendOtp?.isShowBothOptions &&
              config?.login?.otpConfig?.resendOtp?.onSms &&
              config?.login?.otpConfig?.resendOtp?.onWhatsapp && (
                <CustomButtonV2
                  variant="link"
                  disabled={showTimer || isLoading}
                  isLoading={isResendLoading}
                  onClick={() => {
                    if (!showTimer) {
                      trackEvent(EventLabels.CTA_ResendOTP, {
                        screen: "Login",
                      });
                      setIsResendLoading(true);
                      if (!isResendLoading) {
                        apiRepository
                          ?.resendOTP({ token })
                          .then((v) => {
                            setIsResendLoading(false);
                            setOtp("");
                            ToastUtils.showSuccessToast(v?.data?.message);
                            var token = v.headers.authorization;
                            setShowTimer(true);
                            setToken(token);
                          })
                          .catch((error) => {
                            setIsResendLoading(false);
                            ToastUtils.showErrorToast(
                              error?.response?.data?.message
                            );
                            console.log("error", error);
                          });
                      }
                    }
                  }}
                >
                  Resend OTP
                </CustomButtonV2>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}
